import React from 'react';
import { registerWidget } from '@okapi/core';
import { Root, RootProps, RootState } from 'entries/common/widgets';
import { createApi } from 'utils/api';

registerWidget<RootProps, RootState>(`${__NAME__}/root`, state => props => {
  const host = state.env.ORCHESTRATOR_HOST;
  const apiKey = state.env.API_KEY;
  const api = createApi(host, apiKey);
  return <Root {...state} {...props} api={api} />;
});
